import constants from '../constants.js';

const CarSuppliersLocationsIsDeleted = {
  displayName: 'IsDeleted',
  dataAt: 'IsDeleted',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  disabled: false
};

const CarSuppliersLocationsDeliveryCollectionSupport = {
  displayName: 'Delivery Collection Support',
  dataAt: "DeliveryCollectionSupport",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DeliveryCollectionSupport"
};

const CarSuppliersLocationsLongitude = {
  displayName: 'Longitude',
  dataAt: 'Longitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999
};


const CarSuppliersLocationsLatitude = {
  displayName: "Latitude",
  dataAt: "Latitude",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: -9999999999,
  max: 9999999999
};

const CarSuppliersLocationsCountryCode = {
  displayName: "Country Code",
  dataAt: "CountryCode",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single"
};


const CarSuppliersLocationsStateCode = {
  displayName: "State Code",
  dataAt: "StateCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsSupplierCode = {
  displayName: "Supplier Code",
  dataAt: "SupplierCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsLocationName = {
  displayName: "Location Name",
  dataAt: "LocationName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsAddressLine = {
  displayName: "Address Line",
  dataAt: "AddressLine",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsNoRateReturned = {
  displayName: "No Rate Returned",
  dataAt: "NoRateReturned",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CarSuppliersLocationsCityName = {
  displayName: "City Name",
  dataAt: "CityName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsLocationCode = {
  displayName: "Location Code",
  dataAt: "LocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsExtendedLocationCode = {
  displayName: "Extended Location Code",
  dataAt: "ExtendedLocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsTitle = {
  displayName: "Title",
  dataAt: "Title",
  displayAs: "text-input"
};

const CarSuppliersLocationsResource = {
  displayName: "Car Supplier Location",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    CarSuppliersLocationsTitle,
    CarSuppliersLocationsExtendedLocationCode,
    CarSuppliersLocationsLocationCode,
    CarSuppliersLocationsLocationName,
    CarSuppliersLocationsSupplierCode,
    CarSuppliersLocationsNoRateReturned,
    CarSuppliersLocationsAddressLine,
    CarSuppliersLocationsCityName,
    CarSuppliersLocationsStateCode,
    CarSuppliersLocationsCountryCode,
    CarSuppliersLocationsLatitude,
    CarSuppliersLocationsLongitude,
    CarSuppliersLocationsDeliveryCollectionSupport,
    CarSuppliersLocationsIsDeleted
  ],
  endpoint: "CarSupplierLocations",
  routeParamId: "carSupLocationId"
};


let carSuppliersLocationsCols = [
  { name: "Title", key: "Title" },
  { name: "Supplier Code", key: "SupplierCode" },
  { name: "Location Code", key: "LocationCode" },
  { name: "Address Line", key: "AddressLine" },
  { name: "City Name", key: "CityName" },
  { name: "Country Code", key: "CountryCode" },
  { name: "Extended Location Code", key: "ExtendedLocationCode" },
  { name: "Deleted", key: "IsDeleted", excludeFromFilters: true },
];

const CarSuppliersLocationsList = {
  rootNode: true,
  displayName: "Car Supplier Locations",
  displayAs: constants.DISPLAY_AS.SEARCH_BY,
  endpoint: "CarSupplierLocations",
  targetChoices: carSuppliersLocationsCols,
  canSearchDeleted: true,
  resultsSettings: {
    displayName: "Car Supplier Locations",
    gridItem: CarSuppliersLocationsResource,
    gridCols: carSuppliersLocationsCols,
    routeParamId: "carSupLocationId",
    useIdForRouting: true,
  },
};



export default {
  CarSuppliersLocationsList,
  CarSuppliersLocationsResource,
  CarSuppliersLocationsTitle,
  CarSuppliersLocationsExtendedLocationCode,
  CarSuppliersLocationsLocationCode,
  CarSuppliersLocationsLocationName,
  CarSuppliersLocationsNoRateReturned,
  CarSuppliersLocationsAddressLine,
  CarSuppliersLocationsCityName,
  CarSuppliersLocationsStateCode,
  CarSuppliersLocationsCountryCode,
  CarSuppliersLocationsLatitude,
  CarSuppliersLocationsLongitude,
  CarSuppliersLocationsDeliveryCollectionSupport
}



// WEBPACK FOOTER //
// ./src/config/fields/carSuppliersLocations.js